"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const tslib_1 = require("tslib");
const react_1 = tslib_1.__importDefault(require("react"));
const KeyboardArrowDown_1 = tslib_1.__importDefault(require("@mui/icons-material/KeyboardArrowDown"));
const KeyboardArrowUp_1 = tslib_1.__importDefault(require("@mui/icons-material/KeyboardArrowUp"));
const material_1 = require("@mui/material");
const Box_1 = tslib_1.__importDefault(require("@mui/material/Box"));
const Button_1 = tslib_1.__importDefault(require("@mui/material/Button"));
const Menu_1 = tslib_1.__importDefault(require("@mui/material/Menu"));
const MenuItem_1 = tslib_1.__importDefault(require("@mui/material/MenuItem"));
const getStyles = ({ theme }) => ({
    paper: {
        borderRadius: theme.spacing(0.5),
        marginTop: theme.spacing(1),
        minWidth: 180,
        boxShadow: "rgb(255, 255, 255) 0px 0px 0px 0px, rgba(0, 0, 0, 0.05) 0px 0px 0px 1px, rgba(0, 0, 0, 0.1) 0px 10px 15px -3px, rgba(0, 0, 0, 0.05) 0px 4px 6px -2px",
    },
    icon: {
        fontSize: 20,
        color: theme.palette.text.secondary,
        marginRight: theme.spacing(1.5),
    },
});
const BulkActionMenu = (props) => {
    const { label, buttonProps, items, ...menuProps } = props;
    const theme = (0, material_1.useTheme)();
    const styles = getStyles({ theme });
    const [anchorEl, setAnchorEl] = react_1.default.useState(null);
    const open = Boolean(anchorEl);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
    };
    const handleClose = () => {
        setAnchorEl(null);
    };
    return (react_1.default.createElement(Box_1.default, { component: "div" },
        react_1.default.createElement(Button_1.default, { "aria-controls": open ? "bulk-action-menu-button" : undefined, "aria-haspopup": "true", "aria-expanded": open ? "true" : undefined, variant: "outlined", disableElevation: true, onClick: handleClick, endIcon: open ? react_1.default.createElement(KeyboardArrowUp_1.default, null) : react_1.default.createElement(KeyboardArrowDown_1.default, null), ...buttonProps }, label),
        react_1.default.createElement(Menu_1.default, { anchorEl: anchorEl, open: open, onClose: handleClose, PaperProps: { sx: styles.paper }, ...menuProps }, items?.map(({ label, onClick, Icon, iconProps, ...itemProps }, idx) => (react_1.default.createElement(MenuItem_1.default, { key: `${label}-${idx}`, onClick: (event) => {
                handleClose();
                onClick(event);
            }, disableRipple: true, ...itemProps },
            Icon && react_1.default.createElement(Icon, { sx: styles.icon, ...iconProps }),
            label))))));
};
exports.default = BulkActionMenu;
